import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Container, Breadcrumbs, Link } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import VendorUnansweredQuestions from "./VendorUnansweredQuestions";

const UnansweredQuestionsPage = () => {
  const navigate = useNavigate();
  
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {/* Breadcrumb Navigation */}
      <Box sx={{ mb: 3 }}>
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
        >
          <Link
            underline="hover"
            color="inherit"
            href="/vendor/dashboard"
            onClick={(e) => {
              e.preventDefault();
              navigate("/vendor/dashboard");
            }}
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            <HomeIcon sx={{ mr: 0.5, fontSize: 20 }} />
            Vendor Dashboard
          </Link>
          <Typography color="text.primary" sx={{ display: 'flex', alignItems: 'center' }}>
            Unanswered Questions
          </Typography>
        </Breadcrumbs>
      </Box>

      <Box mb={4}>
        <Typography variant="h4" fontWeight={700} gutterBottom>
          Unanswered Questions
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Questions from your products that need your response. You can answer them directly from this page.
        </Typography>
      </Box>

      <VendorUnansweredQuestions />
    </Container>
  );
};

export default UnansweredQuestionsPage;